import { LOGOUT, USER_LANDED } from '../actionTypes';

const initialState = () => ({
  code: null,
  firstName: null,
  lastName: null,
  email: null,
  clusterId: null,
  displayId: null,
});

export const landingReducer = (state = initialState(), action) => {
  switch (action.type) {
    case USER_LANDED:
      const { code, firstName, lastName, email, clusterId, displayId } =
        action.payload.data;
      return {
        ...state,
        code: code,
        firstName: firstName,
        lastName: lastName,
        email: email,
        clusterId: clusterId,
        displayId: displayId,
      };
    case LOGOUT:
      return initialState();
    default:
      return state;
  }
};
